import { integrationsByType } from "../../integrations/integrations";
import type { IntegrationType } from "../../integrations/types";
import type { HookPipelineDto, HookPipelineInfoDto, HookPipelineStepDto } from "../../services/ApiService";
import SubmissionId from "../../state/SubmissionId";
import type {
  HookPipeline,
  HookPipelineInfo,
  HookPipelineStep,
  HookPipelineStepResponse,
} from "../../types/HookPipeline";

export const toHookPipeline = (dto: HookPipelineDto): HookPipeline => ({
  status: dto.status,
  nextExecution: new Date(dto.nextExecution ?? ""),
  submissionId: SubmissionId.from(dto.registrationId),
  steps: dto.steps.map(toHookPipelineStep),
});

const toHookPipelineStep = (dto: HookPipelineStepDto): HookPipelineStep => {
  const { icon, titleKey } = integrationsByType[mapConfigurationKey(dto.configuration.key)];
  return {
    status: dto.status,
    configuration: dto.configuration,
    executionCount: dto.executionCount,
    response: dto.response as HookPipelineStepResponse,
    icon,
    titleKey,
  };
};

export const toHookPipelineInfo = (dto: HookPipelineInfoDto): HookPipelineInfo => ({
  submissionId: SubmissionId.from(dto.registrationId),
  status: dto.status,
});

const mapConfigurationKey = (dto: string): IntegrationType => {
  if (dto === "registrationprocessor") {
    return "mail";
  } else {
    return dto as IntegrationType;
  }
};
